export default __webpack_public_path__ + "static/media/menuly_shopping.0761b8c9.mp4";